import Typography from '../../Typography'
import ModifyBlock from '../ModifyBlock'
import theme from '../../../../theme'
import InfoBox from '../InfoBox'
import { useSelector } from 'react-redux'
import { StoreState } from '../../../../../store/reducer-main'

interface Props{
  onBillsDataModifyPress:()=>void
}

export default function BillingInformationSection({onBillsDataModifyPress}:Props) {

  const { userProfile } = useSelector((state: StoreState) => state.profile);
  

  return (
    <div className='flex justify-between items-center my-5'>
      <div className=' flex-1'>
        <div  className='flex items-center mb-2 flex-1'>
        <Typography variant='display'>
          DATI DI FATTURAZIONE
        </Typography>
        <ModifyBlock onClick={onBillsDataModifyPress} style={{marginLeft:theme.sizing.x1}} modifyItem='Dati di fatturazione'/>
        </div>
        <div className='grid grid-cols-4 gap-4 flex-1'>
            <InfoBox title='Nome' content={userProfile?.stripeCustomer.metadata.name??""}/>
            <InfoBox title='Cognome' content={userProfile?.stripeCustomer.metadata.surname??""}/>
            <InfoBox title='Codice Postale' content={userProfile?.stripeCustomer.metadata.postalCode??""}/>
        </div>
        <div className='grid grid-cols-5 gap-4 flex-1 my-4'>
            <InfoBox title='Indirizzo' content={userProfile?.stripeCustomer.metadata.address??""}/>
            <InfoBox title='Ragione Sociale' content={userProfile?.stripeCustomer.metadata.companyName??""}/>
            <InfoBox title='Partita Iva' content={userProfile?.stripeCustomer.metadata.vatNumber??""}/>
            <InfoBox title='SDI' content={userProfile?.stripeCustomer.metadata.sdi??""}/>
          {/* </div> */}
        </div>
      </div>
   </div>
  )
}
